import Api from "./Api.js";

const resource = "/tracking";

export default {
  update(AutoNumber, attributes) {
    return Api.patch(`${resource}/${AutoNumber}`, attributes);
  },
  delete(AutoNumber) {
    return Api.delete(`${resource}/${AutoNumber}`);
  },
};
